import { Component, inject, OnInit } from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { RouterLink } from "@angular/router";
import { AppService } from "src/app-legacy/core/services/app.service";
import { PasswordExpiryService } from "./password-expiry.service";

@Component({
	selector: "app-password-expiry-alert",
	imports: [MatIcon, RouterLink],
	templateUrl: "./password-expiry-alert.component.html",
})
export class PasswordExpiryAlertComponent implements OnInit {
	private passwordExpiryService = inject(PasswordExpiryService);
	private app = inject(AppService);

	visible = false;
	message?: string;

	username = this.app.currentUser?.user.username;

	ngOnInit() {
		this.passwordExpiryService.getPasswordExpiryInfo().subscribe((data) => {
			this.visible = data.passwordExpired;
			this.message = data.message;
		});
	}

	close() {
		this.visible = false;
	}
}
